@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';

.widget-picker {
  padding: @space-4 @space-12;
  border: 1px solid var(--grey-300);
  border-bottom: none;
}

.widget-picker-header {
  display: none;
}

.widget-list {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: @space-8;
  padding: 0;
}

.widget-element {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: grab;
}

.widget-element:hover {
  background-color: var(--grey-200);
}

.widget-element:active {
  cursor: grabbing;
  background-color: var(--grey-300);
}

.widget-icon {
  svg {
    width: 16px;
    height: 16px;
  }
}

.widget-element:hover .widget-icon {
  color: var(--blue-600);
}
